import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Container, Row, Col, Card, Form, Button, Alert, Image} from "react-bootstrap";
import {Footer} from "@/components/footer";
import logo from "@/assets/logo.svg";

export function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await fetch("/auth/login", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({username, password}),
            });

            if (!response.ok) {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error("Invalid credentials");
            }

            const data = await response.json();
            localStorage.setItem("token", data.token);
            navigate("/week-plan");
        } catch (err) {
            setError("Invalid username or password");
        }
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-center text-center mb-4">
                <Col xs={12} md={6} lg={4}>
                    <Image src={logo} alt="HippoTrack Logo" width={64} height={64} className="mb-3"/>
                    <h1 className="fw-bold">HippoTrack</h1>
                    <p className="text-muted mb-1">Erfassung von Therapieeinheiten</p>
                    <p className="small text-muted">
                        HippoTrack unterstützt Therapeut:innen beim Dokumentieren und Auswerten von Einheiten in der
                        pferdegestützten Therapie.
                    </p>
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col xs={12} md={6} lg={4}>
                    <Card className="shadow">
                        <Card.Body>
                            <Card.Title className="text-center mb-4">Anmeldung</Card.Title>
                            <Form onSubmit={handleLogin}>
                                <Form.Group className="mb-3" controlId="username">
                                    <Form.Label>Benutzername</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="password">
                                    <Form.Label>Passwort</Form.Label>
                                    <Form.Control
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                {error && <Alert variant="danger">{error}</Alert>}

                                <div className="d-grid">
                                    <Button variant="primary" type="submit">
                                        Anmelden
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Footer/>
        </Container>
    );
}